import { Component, Input, OnInit } from "@angular/core";
import { ReportVisualEvents } from "../../../../models/report-preview/report-visual-events";
import { Notifier, OfflineReportPreviewService } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-visual-events",
  templateUrl: "./visual-events.component.html",
  styleUrls: ["./visual-events.component.scss"],
  standalone: false
})
export class VisualEventsOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public visualEventsKey: string;
  @Input() public elementLocation: string;

  public notifier: Notifier;
  public reportVisualEvents: ReportVisualEvents;
  public resizeMarkerSize: number;
  public resizing: boolean;
  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: "visual-events.component",
      ids: { pageId: this.pageKey, elementId: this.visualEventsKey }
    };
    this.reportVisualEvents = this.designService.getVisualEvents(this.visualEventsKey);
  }

  public onClick(event: MouseEvent) {}

  public getStyles(reportVisualEvents: ReportVisualEvents): object {
    return {
      width: reportVisualEvents.width,
      height: reportVisualEvents.itemContainerHeight,
      fontSize: reportVisualEvents.fontSize,
      fontFamily: reportVisualEvents.fontFamily,
      border: `${reportVisualEvents.borderWidth} ${reportVisualEvents.borderStyle} ${reportVisualEvents.borderColor}`,
      padding: `${reportVisualEvents.itemMargin}mm`
    };
  }

  public getContainerStyle(reportVisualEvents: ReportVisualEvents): object {
    return {
      top: reportVisualEvents.top,
      left: reportVisualEvents.left,
      width: reportVisualEvents.width,
      height: reportVisualEvents.height
    };
  }

  public getItemStyles(reportVisualEvents: ReportVisualEvents): object {
    return {
      width: reportVisualEvents.width,
      height: reportVisualEvents.height,
      border: `${reportVisualEvents.borderWidth} ${reportVisualEvents.borderStyle} ${reportVisualEvents.borderColor}`,
      margin: reportVisualEvents.itemMargin
    };
  }
}
